import React from 'react';
import "./Sec2Why.css";


function Sec2Why() {

  const centers = [
    {
      "number": "480+",
      "title": "Total Number of Mid-market GCCs (FY2025)"
    },
    {
      "number": "210K+ ",
      "title": "Total Installed Mid-market GCC Talent (FY2025E)"
    },
    {
      "number": "45+",
      "title": "Mid-market GCCs setup in the last two years (FY2023-2025E)"
    },
    {
      "number": "27%",
      "title": "of total GCCs are Mid-market GCCs (FY2025E)"
    }
  ];

  const handleScroll = () => {
    const target = document.getElementById('image-preview-slider');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="sec3why-container container">
      <div className="sec3why-content">
        <h1 className="Title">Understanding Mid-Market GCCs in India</h1>

        <div className="sec3why-text">
          <div className="sec3why-paragraph">
            <p className='text'> Mid-market GCCs are operating differently, and in some ways, more strategically. They’re <b>1.3X more likely to be involved in transformation-focused work</b>, and they’re rapidly anchoring critical roles in India, especially in Product Management, where nearly half of the global talent in this cohort is now based out of India.
            That’s not a coincidence. </p>
            <p className='text'><b>These organizations are leveraging India not merely for cost arbitrage, but for something far more valuable - talent density, innovation velocity, and operational agility.</b> Cities like Bengaluru and Hyderabad have become breeding grounds for this wave, offering mature ecosystems tailored to fast-growing companies. And as government incentives align with private ambition, India is emerging as the go-to choice not just for where to scale, but how to scale smartly.
           {/* <h2>This solid foundation has set the stage for <a href="https://zinnov.com/centers-of-excellence/succession-planning-drive-global-roles-from-india-gccs-blog/" target='_blank'>growing global roles</a>, poised to reach 30,000 by 2030, at maturing GCCs.</h2>   */}
           <br/><br/>
           Even more telling is the kind of work being done. <b>Mid-market GCCs are leaning into DeepTech</b> with a 1.5X higher share of talent in AI, Cloud, Cybersecurity, and Data Science. These are not back offices, they are frontline innovation hubs. In fact, the trend is increasingly toward a <b>“GCC-as-a-Service” model</b>, where Mid-market Firms embed agile, product-led teams in India to drive global transformation from the inside out.</p>
          </div>

          <div className="centers-wrapper" onClick={handleScroll}>
            {centers.map((item, index) => (
              <div className="Centers" key={index}>
                <h3 className="centers-num centers-text">{item.number}</h3>
                <p className="centers-details centers-text">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sec2Why;
